import { parseFormContent } from "../lib/formContent";

export default function FormContentText({ content, className = "" }) {
  return (
    <p className={`whitespace-pre-wrap ${className}`}>
      {parseFormContent(content).map((run, index) => (
        <span
          key={index}
          className={`${run.bold ? "font-semibold" : ""} ${run.underline ? "underline" : ""} ${run.size === "xlarge" ? "text-xl leading-relaxed" : run.size === "large" ? "text-base leading-relaxed" : ""}`}
        >
          {run.text}
        </span>
      ))}
    </p>
  );
}
